
import { Component, Prop, Vue } from 'vue-property-decorator'
import User from '@/models/User'
import Icon from '@/components/Icon.vue'
import { AttachmentType } from '@/components/Messages/AddAttachment.vue'
import { namespace } from 'vuex-class'
import Notification from '@/classes/Notification'
import i18n from '@/i18n'
import FileDownloadLink from '@/components/FileDownloadLink.vue'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import { Vessel } from '@/models/Vessel'
import { Document } from '@/models/Document'
import VesselDocumentExpiryDialog from '@/components/Profile/VesselDocumentExpiryDialog.vue'

const Auth = namespace('auth')
const VesselDetails = namespace('vesselDetails')

@Component({
	components: {
		VesselDocumentExpiryDialog,
		FileDownloadLink,
		Icon,
		ConfirmationDialog
	}
})
export default class VesselDocuments extends Vue {
	@Prop({ required: true })
	vessel!: Vessel | null

	@VesselDetails.State('documents')
	documents!: Array<Document>

	@Auth.Getter('hasAccountingMembership')
	hasAccountingMembership!: boolean

	@Auth.Getter('hasPrivateClientCommunicationMembership')
	hasPCCMembership!: boolean

	@VesselDetails.Action('fetchDocuments')
	fetchDocuments

	@VesselDetails.Mutation('removeDocument')
	removeDocumentFromState

	user: User | null = null

	showAddAttachment = false
	isLoading = true
	documentsLoaded = false

	deleteConfirmationOpen: boolean = false
	documentExpiryDialogOpen: boolean = false
	selectedDocument: Document | null = null

	async created() {
		this.user = await User.fetchMeLazy()
		await this.syncDocuments()
	}

	async syncDocuments() {
		this.isLoading = true
		await this.fetchDocuments()
		this.documentsLoaded = true
		this.isLoading = false
	}

	async fileUploaded(uploadedDocument: Document, attachmentType: AttachmentType | null = null) {
		this.showAddAttachment = false
		this.$emit('fileUploaded', uploadedDocument)
		await this.syncDocuments()
		if (attachmentType?.canExpire) {
			this.selectedDocument =
				this.documents.find((document) => document.getApiId() === uploadedDocument.getApiId()) ?? null
			this.documentExpiryDialogOpen = true
		}
	}

	async removeDocument() {
		if (!this.selectedDocument) return
		this.deleteConfirmationOpen = false
		this.selectedDocument.isLoading = true
		const docToRemove = this.selectedDocument
		this.selectedDocument = null

		await docToRemove.delete()
		await Notification.Success(i18n.t('transports.document.deleteSuccess'))
		this.removeDocumentFromState(docToRemove)
	}
}
